/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Team_NextInputs */

const en_landing_team_next = /** @type {(inputs: Landing_Team_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next open`)
};

const pl_landing_team_next = /** @type {(inputs: Landing_Team_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbliższy wolny`)
};

/**
* | output |
* | --- |
* | "Next open" |
*
* @param {Landing_Team_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_team_next = /** @type {((inputs?: Landing_Team_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Team_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_team_next(inputs)
	return en_landing_team_next(inputs)
});